export default {
  eyebrow: 'Partnerportaal',
  title: 'Account',
  description: 'Uw partneraccountgegevens.',
  page: {
    read_only_notice: 'Alleen-lezen. Klik op Bewerken om een waarde te wijzigen.',
    editing_notice: 'Bewerken — wijzigingen zijn zichtbaar voor uw team en klanten.',
  },
  profile: {
    form: {
      name: {
        label: 'Partnernaam',
        hint: 'De juridische / entiteitsnaam. Gebruikt op facturen.',
      },
      display_name: {
        label: 'Weergavenaam voor consumenten',
        hint: 'Het „Mogelijk gemaakt door ___"-label dat uw klanten bij uw restaurants zien. Standaard de partnernaam als het veld leeg is.',
      },
      support_email: {
        label: 'Contacte-mail',
        hint: 'Waar Foodamigos en uw klanten u kunnen bereiken. Uw inlogmailadres blijft ongewijzigd.',
      },
      invoicing_emails: {
        label: 'E-mails voor facturen',
        hint: 'Ontvangstbewijzen voor facturen die aan u worden gefactureerd, worden naar elk van deze adressen gestuurd. Laat leeg om uw inlog-e-mailadres te gebruiken.',
        placeholder: 'Uw inlog-e-mailadres',
      },
    },
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  toasts: {
    load_error: 'Accountgegevens konden niet worden geladen.',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
